import React, { useEffect, useState } from "react";
import { getProfile } from "../../services/localStorageServices";
import Header from "../Header";
import ProfileBanner from "../MobileProfile/ProfileBanner";
import { LiaArrowLeftSolid } from "react-icons/lia";
import { Avatar, Button, Tabs } from "antd";
import { FaUserAlt } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { MdLocationOn } from "react-icons/md";
import { FaTransgender } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import ProfileData from "./ProfileData";
import AccountDetail from "./AccountDetail";
import Review from "./Review";
import Orders from "./Orders";
import NavbarBottom from "../NavbarBottom";
import PhoneHeader from "../PhoneHeader";
import { IoMdLogOut } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import BannerComp from "../BannerComp";
import profileBanner from "../../Assets/profileBanner.jpg";
import Footer from "../Footer";
import moment from "moment";

const Profile = () => {
  const { profile } = getProfile();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const items = [
    {
      key: "1",
      label: "Profile",
      children: <ProfileData />,
    },
    {
      key: "2",
      label: "Account",
      children: <AccountDetail />,
    },
    profile.verify !== "0" && {
      key: "3",
      label: "Orders",
      children: <Orders />,
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("profile");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <Header />

      <BannerComp
        title="My Profile"
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "Profile",
          },
        ]}
        image={profileBanner}
      />
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-4">
            <div
              className="profileCard d-flex align-items-center flex-column justify-content-center"
              style={{
                padding: "20px 10px",
                boxShadow: "0 0 3px #808080",
                borderRadius: "10px",
              }}
            >
              <Avatar size={80} icon={<FaUserAlt />} />
              <h3>{profile.name}</h3>
              <p className="d-flex align-items-center justify-content-between text-muted w-100">
                <span style={{ fontSize: ".9rem" }}>
                  <IoCall />
                  &nbsp;{profile.number}
                </span>
                &nbsp;
                <span style={{ fontSize: ".9rem" }}>
                  <MdEmail />
                  &nbsp;{profile.user_email}
                </span>
              </p>
              <p style={{ fontSize: ".9rem" }} className="text-muted w-100">
                <MdLocationOn />
                {profile.address_one} {profile.address_two}, {profile.city}{" "}
                {profile.state} {profile.country} {profile.zip_code}
              </p>
              <p className="d-flex align-items-center justify-content-between text-muted w-100">
                <span style={{ fontSize: ".9rem" }}>
                  <FaTransgender />
                  &nbsp;{profile.gander}
                </span>
                &nbsp;
                {!isNaN(new Date(profile.dob)) && (
                  <span style={{ fontSize: ".9rem" }}>
                    <MdDateRange />
                    &nbsp;{moment(profile.dob).format("DD MMM YYYY")}
                  </span>
                )}
              </p>
              <Button
                icon={<IoMdLogOut />}
                onClick={handleLogout}
                className="bg-danger text-white w-100"
                style={{ minHeight: "40px" }}
              >
                Log Out
              </Button>
            </div>
          </div>
          <div className="col-md-8">
            <Tabs defaultActiveKey="1" items={items} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Profile;
